import { WorkFrom } from "../../models/UserMast";

export const EmptyUser = {
    login_ID: undefined,
    user_Name: '',
    login_Name: '',
    user_EmailID: '',
    branch_ID: 0,
    branchName: '',
    user_Status: false,
    temp_Inactive: false,
    login_Password: '',
    user_PhoneNo: '',
    user_Ext_No: '',
    user_GtalkID: '',
    user_YahooID: '',
    workFrom: WorkFrom.Onsite,
    date_Of_Joining: null,
}